import { format, parseISO, isValid } from 'date-fns';
import { ko } from 'date-fns/locale';

/**
 * formatDateYYYYMMDD('2025-11-11T10:30:00Z') => '2025-11-11'
 */
export const formatDateYYYYMMDD = (inputDate: string | Date): string => {
  if (!inputDate) return '';

  try {
    const parsedDate =
      typeof inputDate === 'string' ? parseISO(inputDate) : inputDate;
    if (!isValid(parsedDate)) return '';

    return format(parsedDate, 'yyyy-MM-dd');
  } catch {
    return '';
  }
};

/**
 * formatDateKo('2025-11-11T10:30:00Z') => '2025. 11. 11.'
 */
export const formatDateKo = (inputDate: string | Date): string => {
  if (!inputDate) return '';

  try {
    const parsedDate =
      typeof inputDate === 'string' ? parseISO(inputDate) : inputDate;
    if (!isValid(parsedDate)) return '';

    return format(parsedDate, 'P', { locale: ko });
  } catch {
    return '';
  }
};

/**
 * formatDateTimeKo('2025-11-11T10:30:00Z') => '2025. 11. 11. 오전 10:30:00'
 */
export const formatDateTimeKo = (inputDate: string | Date): string => {
  if (!inputDate) return '';

  try {
    const parsedDate =
      typeof inputDate === 'string' ? parseISO(inputDate) : inputDate;
    if (!isValid(parsedDate)) return '';

    return format(parsedDate, 'Pp', { locale: ko });
  } catch {
    return '';
  }
};
